// extracted by mini-css-extract-plugin
module.exports = {"paymentIcons":"style_paymentIcons__28IYk","paymentIcon":"style_paymentIcon__1YboD"};